import type {
  FileReviewAnchor,
  FileReviewMessage,
  FileReviewThreadDto,
  PdfHighlightArea
} from '@jarvis/platform-file-review';

export type { PdfHighlightArea };

/** PDF anchor from the unified file review thread payload. */
export type PdfReviewAnchor = FileReviewAnchor & {
  kind: 'pdf';
  pageIndex: number;
  areas: PdfHighlightArea[];
};

export type PdfReviewMessage = FileReviewMessage;

export type PdfReviewThreadDto = FileReviewThreadDto;

export function pdfAnchorsFromThread(thread: FileReviewThreadDto | null | undefined): PdfReviewAnchor[] {
  if (!thread) return [];
  return thread.anchors.filter(
    (a: FileReviewAnchor): a is PdfReviewAnchor => a.kind === 'pdf' && Array.isArray(a.areas)
  );
}
